import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { ClaimDto } from "../../../services/dto";
import * as yup from "yup";
import { LookupDto } from "../../../services/dto/account/lookupDto";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { convertToDropdownOptions } from "./claimPage";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface ClaimFormProps {
  loading?: boolean;
  data?: ClaimDto;
  show: boolean;
  claimTypes: LookupDto[] | [];
  onHide: () => void;
  onSave: (values: ClaimDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  claimTypeId: yup
    .string()
    .required("Claim Type is required")
    .test(
      "not-empty",
      "Claim Type is required",
      (value) => value !== Constants.emptyGuid
    ),
  sortValue: yup.number().required("Sort Value is required."),
});

const getTitle = (id: string | undefined): string =>
  StringHelper.whenNullOrEmpty(id, Constants.emptyGuid) === Constants.emptyGuid
    ? "New Claim"
    : "Edit Claim";

export const ClaimForm = (props: ClaimFormProps) => {
  const title: string = getTitle(props.data?.id);
  const dropdownOptions: DropdownOption[] = convertToDropdownOptions(
    props.claimTypes
  );
  const handleSubmit = (formData: ClaimDto) => {
    return Promise.resolve(props.onSave(formData)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      enableReinitialize
      title={title}
      initialValues={{
        ...props.data,
        sortValue: props.data?.sortValue || 100,
      }}
      validationSchema={validationSchema}
      onHide={props.onHide}
      on_Submit={handleSubmit}
    >
      <Form.Text
        name="name"
        label="Name"
        placeholder="Enter text"
        isLoading={props.loading}
      />

      <Form.TextArea
        name="description"
        label="Description"
        rows={3}
        isLoading={props.loading}
      />

      <Form.Dropdown
        name="claimTypeId"
        label="Claim Type"
        isLoading={props.loading}
        blankOption={{
          key: Constants.emptyGuid,
          value: Constants.emptyString,
          display: "Select Claim Type",
        }}
        options={dropdownOptions}
      ></Form.Dropdown>
      <Form.Text
        name="sortValue"
        label="Sort Value"
        placeholder="Enter text"
        isLoading={props.loading}
      />
    </Drawer.Form>
  );
};
